import styled from 'styled-components';
import { Box } from '@material-ui/core';

export const SpacedInputBox = styled(Box)`
    ${({ theme }) => `
        margin: 0 ${theme.spacing(.5)}px;
    `}
`;
